import TabMenu from './TabMenu';
export { TabMenu };
export default TabMenu;
